import axios from "axios";
import { getKeyCookie } from "~/utils/func";

const accessToken = window.localStorage.getItem("jwt") || getKeyCookie("token");
axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

const prepareConfig = (config = {}) => {
  const finalConfig = { ...config };
  if (finalConfig.headers) {
    finalConfig.headers = { ...finalConfig.headers };
    if (
      finalConfig.headers.token === "" ||
      finalConfig.headers.Authorization === ""
    ) {
      delete finalConfig.headers.token;
      delete finalConfig.headers.Authorization;
      if (axios.defaults.headers.common) {
        delete axios.defaults.headers.common.Authorization;
      }
    } else if (finalConfig.headers.token) {
      finalConfig.headers.Authorization = `Bearer ${finalConfig.headers.token}`;
      delete finalConfig.headers.token;
    }
  }
  return finalConfig;
};

export const getHttpRequest = async url => axios.get(url);
export const postHttpRequest = async url => axios.post(url);
export const deleteHttpRequest = async url => axios.delete(url);

export const getHttpRequestAsync = async (url, config = {}) =>
  axios.get(url, prepareConfig(config));

export const getHttpRequestParamsAsync = async (url, params, config = {}) =>
  axios.get(url, prepareConfig({ params: { ...params }, ...config }));

export const deleteHttpRequestAsync = async (url, config = {}) =>
  axios.delete(url, prepareConfig(config));

export const deleteHttpRequestParamsAsync = async (url, params, config = {}) =>
  axios.delete(url, prepareConfig({ params: { ...params }, ...config }));

export const postHttpRequestAsync = async (url, data = {}, config = {}) =>
  axios.post(url, data, prepareConfig(config));

export const putHttpRequestAsync = async (url, data = {}, config = {}) =>
  axios.put(url, data, prepareConfig(config));

export const putHttpRequest = (url, data = {}, config = {}) =>
  axios.put(url, data, prepareConfig(config));

export const patchHttpRequestAsync = async (url, data = {}, config = {}) =>
  axios.patch(url, data, prepareConfig(config));

export const patchHttpRequest = (url, data = {}, config = {}) =>
  axios.patch(url, data, prepareConfig(config));
